export default __webpack_public_path__ + "9cd7fdde472c940137c5bf21af0c94ea.png";